import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { SOFTLINE_PERMISSION_ABAU_SALE_STATISTICS } from './sale-statistics.shared';

export const routes: Routes = [
  {
    path: 'abau-sale-statistics',
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_ABAU_SALE_STATISTICS },
    children: [
      {
        path: 'query',
        loadComponent: () => import('./pages/query/query.component'),
      },
      {
        path: '',
        loadComponent: () => import('./pages/result/result.component'),
      },
    ],
  },
];
